import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFactCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.66732 14C2.30065 14 1.98676 13.8694 1.72565 13.6083C1.46454 13.3472 1.33398 13.0333 1.33398 12.6667V3.33333C1.33398 2.96667 1.46454 2.65278 1.72565 2.39167C1.98676 2.13056 2.30065 2 2.66732 2H13.334C13.7007 2 14.0145 2.13056 14.2757 2.39167C14.5368 2.65278 14.6673 2.96667 14.6673 3.33333V12.6667C14.6673 13.0333 14.5368 13.3472 14.2757 13.6083C14.0145 13.8694 13.7007 14 13.334 14H2.66732ZM3.33398 11.3333H6.66732V10H3.33398V11.3333ZM9.70065 10L13.0007 6.7L12.0507 5.75L9.70065 8.11667L8.75065 7.16667L7.81732 8.11667L9.70065 10ZM3.33398 8.66667H6.66732V7.33333H3.33398V8.66667ZM3.33398 6H6.66732V4.66667H3.33398V6Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgFactCheck);
export default ForwardRef;
